import { Component, effect, input, output, signal } from '@angular/core';
import { HistoryAnswer } from "../history-answer/history-answer";
import { Question, Questionnaire, Subquestion } from '../models';

@Component({
    selector: 'fgai-page',
    imports: [HistoryAnswer],
    templateUrl: './page.component.html',
    styleUrl: './page.component.scss',
})
export class PageComponent {
    questionnaire = input<Questionnaire>();
    question = input<Question>();
    readonly = input<boolean>();
    hideExplainDiff = input<boolean>(false);

    explainDiffChange = output<string>();
    answersChange = output<{ [subquestionId: string]: string }>();

    explainDiff = signal<string>('');
    answers = signal<{ [subquestionId: string]: string }>({});

    subquestions = signal<Subquestion[]>([]);

    constructor() {
        // update the answers if the question if updated
        effect(() => {
            const question = this.question();
            if (!question) {
                return;
            }

            const answers: { [subquestionId: string]: string } = {};

            for (let subq of question.subquestions) {
                answers[subq.id] = subq?.answer?.content ?? '';
            }

            this.answers.set(answers);
            this.explainDiff.set(question.explain_diff);
            this.subquestions.set(question.subquestions);
        })
    }

    updateAnswer(subquestionId: string, $event: Event) {
        const updatedText = $event.target ? (<HTMLTextAreaElement>$event.target).value : '';
        this.updateAnswerText(subquestionId, updatedText);
    }

    updateAnswerText(subquestionId: string, content: string, emit = true) {
        const currentAnswers = this.answers();

        // only emit changes
        if (currentAnswers[subquestionId] === content) {
            return;
        }

        const answers = {
            ...currentAnswers,
            [subquestionId]: content
        };

        this.answers.set(answers);

        if (emit) {
            this.answersChange.emit(answers);
        }
    }

    updateExplainDiff($event: Event) {
        const text = $event.target ? (<HTMLTextAreaElement>$event.target).value : '';
        this.explainDiff.set(text);
        this.explainDiffChange.emit(text);
    }

    copyQuestion(question: Question) {
        const current = this.question();
        if (!current) {
            return;
        }

        const answers = { ...this.answers() };
        for (const i in current.subquestions) {
            const sq = current.subquestions[i];
            answers[sq.id] = question.subquestions[i]?.answer?.content ?? '';
        }

        // group the update in one go
        this.answers.set(answers);
        this.answersChange.emit(answers);
    }
}
